import { createReducer, on } from '@ngrx/store';
import { DashboardActions } from './dashboard.actions';
import { DashboardData } from '@core/interface/dashboard';

export const DashboardFeatureKey = 'dashboard';

export interface DashboardState {
  dashboardData: DashboardData | null;
  isLoading: boolean;
}

export const initialState: DashboardState = {
  dashboardData: null,
  isLoading: false,
};

export const DashboardReducer = createReducer(
  initialState,
  on(DashboardActions.loadDashboardData, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(DashboardActions.loadDashboardDataSuccess, (state, { data }) => ({
    ...state,
    dashboardData: data,
    isLoading: false,
  })),
  on(DashboardActions.loadDashboardDataFailure, (state) => {
    return { ...state, isLoading: false, dashboardData: null };
  }),
  on(DashboardActions.resetDashboardData, (state) => ({
    ...state,
    dashboardData: null,
  }))
);
